export default `go get github.com/golang-jwt/jwt`;
